import { render, staticRenderFns } from "./EducationalGroupTransferTable.vue?vue&type=template&id=50b18778&"
import script from "./EducationalGroupTransferTable.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTransferTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports